import { useEffect, useState } from 'react'
import { useStore } from '../state/store'
import { useT } from '../i18n'
import { NotumMark } from './icons'

function timeShort(ts: number): string {
  const d = new Date(ts)
  return `${String(d.getHours()).padStart(2, '0')}:${String(d.getMinutes()).padStart(2, '0')}`
}

export function StatusBar() {
  const result = useStore((s) => s.result)
  const doc = useStore((s) => s.doc)
  const view = useStore((s) => s.view)
  const savedAt = useStore((s) => s.savedAt)
  const workerHealth = useStore((s) => s.workerHealth)
  const t = useT()

  // Re-render every 30s so the autosave time stays honest.
  const [, bump] = useState(0)
  useEffect(() => {
    const t = setInterval(() => bump((n) => n + 1), 30000)
    return () => clearInterval(t)
  }, [])

  return (
    <footer className="status-bar">
      <span className="stat">
        {doc.canvas.width} x {doc.canvas.height} mm
      </span>
      {view && <span className="stat">{view.scale.toFixed(1)} px/mm</span>}
      {result && (
        <>
          <span className="stat">{result.stats.instances} instances</span>
          <span className="stat">{result.stats.holes} holes</span>
          <span className="stat">{result.stats.ms.toFixed(0)} ms</span>
          {result.stats.capped && <span className="warn">Instance cap reached, increase spacing</span>}
        </>
      )}
      <span className="status-spacer" />
      {workerHealth === 'idle' ? (
        <a
          className="notum-link"
          href="https://n-r.hr"
          target="_blank"
          rel="noopener noreferrer"
          title="Made by Notum Robotics"
          aria-label="Notum Robotics website"
        >
          <NotumMark size={13} />
        </a>
      ) : (
        <span title="Generation worker health">
          <span className={`status-dot ${workerHealth}`} />
          {workerHealth === 'busy' ? t('status.generating', 'generating') : 'engine restarted'}
        </span>
      )}
      <span title="Designs autosave to this browser">
        {savedAt ? `saved ${timeShort(savedAt)}` : 'not saved yet'}
      </span>
      <span className="hint" style={{ margin: 0 }}>
        {t('status.shortcuts', 'press ? for shortcuts')}
      </span>
    </footer>
  )
}
